import { createContext } from 'react'

import {
  AuthorizationEntry,
  CustomerEntry,
  InventoryPartEntry,
  RepairOrderExpanded,
  RepairPaymentEntry,
  ServiceExpanded,
  ShopEntry,
  UserProfile,
  VehicleEntry
} from '../../sdk'

export interface InvoiceContextValues {
  shopProfile: ShopEntry | undefined
  repairOrder: RepairOrderExpanded | undefined
  serviceAdvisor: UserProfile | undefined | null // null means there is no service advisor while undefined means the service advisor is loading
  customer: CustomerEntry | undefined
  vehicle: VehicleEntry | undefined
  services: ServiceExpanded[] | undefined
  authorizations: AuthorizationEntry[] | undefined
  payments: RepairPaymentEntry[] | undefined
  serviceTechnicians: UserProfile[] | undefined
  serviceInventoryParts: InventoryPartEntry[] | undefined // inventory parts that are related to inventory instances that are related to services
}

export const InvoiceContext = createContext<InvoiceContextValues>({
  shopProfile: undefined,
  repairOrder: undefined,
  serviceAdvisor: undefined,
  customer: undefined,
  vehicle: undefined,
  services: undefined,
  authorizations: undefined,
  payments: undefined,
  serviceTechnicians: undefined,
  serviceInventoryParts: undefined
})
